import { MatDialog } from '@angular/material/dialog'
import { ImportDialogComponent, ImportDialogData } from 'src/app/components/wizards/import.dialog.component';
import { InputDialogData, InputDialogComponent, InputDialogReturnData } from "src/app/components/wizards/input.dialog.component"
import { openDialogGetResult } from 'src/app/helpers/angular-helpers'
import { capitalize, makeStringFileNameSafe, save2DStringArrayToCSVFile, sleepForMS } from '../../helpers/helpers'
import { ImportType } from 'globals/store/import.data';
import { NestedTableComponent } from './../../components/nested-table/nested-table.component';
import * as XLSX from 'xlsx';
import { EntitySelectorAddNewReturnData, EntitySelectorData, EntitySelectorDialogComponent } from '../../components/entities/entity-selector.dialog.component';
import { Entity, EntityName, EntityServiceFunctions } from 'globals/store/entity.data';
import { Budget } from 'globals/store/reselectors/budget.data';
import { getConversionRate } from 'globals/helpers/budget.helper';
import { RankingDialogData, RankSelectDialogComponent } from '../sponsors/rank-select.dialog.component';
import { CustomQuestion, CustomQuestionType, Ranking } from 'globals/store/events.data';
import { Performer } from 'globals/store/performers.data';
import { CoreEntityType } from 'globals/store/share.data';
import { CustomQuestionDialog, CustomQuestionDialogData } from '../../components/entities/custom-question.dialog.component';
import { EntityBase } from 'globals/store/entity.shared.data';
import { BaseTableData } from '../../helpers/table-column-types';
import { createId, flatten } from 'globals/helpers/helpers';

export const addAPerformer = async (event: Event, dialog, performersService, nextDialogMethod) => 
  addANew(event, 'Performer', dialog, performersService.addPerformer.bind(performersService), nextDialogMethod)

export const addASponsor = async(event: Event, dialog, sponsorsService, nextDialogMethod) => 
  addANew(event, 'Sponsor', dialog, sponsorsService.addSponsor.bind(sponsorsService), nextDialogMethod)

export const addAResource = async(event: Event, dialog, resourceService, nextDialogMethod) => 
addANew(event, 'Resource', dialog, resourceService.addResource.bind(resourceService), nextDialogMethod)

export const addAnAttendee = async(event: Event, dialog, attendeeService, nextDialogMethod) => 
  addANew(event, 'Attendee', dialog, attendeeService.addAttendee.bind(attendeeService), nextDialogMethod)

export const addAnExhibitor = async(event: Event, dialog, exhibitorsService, nextDialogMethod) => 
  addANew(event, 'Exhibitor', dialog, exhibitorsService.addExhibitor.bind(exhibitorsService), nextDialogMethod)

export const addAnExhibitorStand = async(event: Event, dialog, exhibitorsService, nextDialogMethod) => 
  addANew(event, 'Exhibitor Stand', dialog, exhibitorsService.addExhibitorStand.bind(exhibitorsService), nextDialogMethod)

export const addAnAsset = async(event: Event, dialog, assetService, nextDialogMethod) => 
  addANew(event, 'Asset', dialog, assetService.addAsset.bind(assetService), nextDialogMethod)

  
export interface ChooseOrAddTypesData<S extends EntityServiceFunctions, E extends EntityBase> {
  entityService: S
  dialog: MatDialog,
  position: RankingDialogData['position'], 
  types: Ranking[], 
  entities: E[],
  single: boolean
  typeName: string
  isCategory?: boolean
  canDeselect?: boolean

}
export const chooseOrAddEntityTypes = async<S extends EntityServiceFunctions, E extends EntityBase>({ entityService, dialog, position, types, entities, single, typeName, isCategory, canDeselect }: ChooseOrAddTypesData<S, E>) => {

  const data: RankingDialogData = {
    position,
    ranks: types,
    selectedRankId: entities.length === 1 && single ? entities[0].entityTypeId || 'default' : null,
    type: isCategory ? typeName : `${typeName} type`,
    isCategory
  }

  const oldId = data.selectedRankId
  const oldLevelsSerialized = JSON.stringify(data.ranks)

  const { selectedRankId, ranks } = await openDialogGetResult<{ selectedRankId: string, ranks: Ranking[] }>(dialog, RankSelectDialogComponent, { width: '300px', disableClose: false, data, backdropClass: 'clear' }) // mutates data in place
 

  if (JSON.stringify(ranks) !== oldLevelsSerialized) {
    await entityService.updateTypes(ranks)
  }

  if ((selectedRankId || canDeselect) && oldId !== selectedRankId) {
    entities.forEach(p => p.entityTypeId = selectedRankId)
    await entityService.updateEntities(entities)
  }

  console.log({ selectedRankId, ranks, oldId })
}

export const addANew = async(event: Event, type: EntityName, dialog, addingServiceMethod, nextDialogMethod) => {
  const rect = (<HTMLElement>event.target).getBoundingClientRect()
  const width = 320 // NEEDS to be wider for performer, or you need to deal with padding issues.  This is a better solution imo
  const data: EntitySelectorData = {
    entityName: type,
    entityHolderName: 'Event',
    isAddNew: true,
    rect,
  }
  const result = await openDialogGetResult<EntitySelectorAddNewReturnData>(dialog, EntitySelectorDialogComponent, { width: `${width}px`, autoFocus: true, backdropClass: 'clear', data })
  if (!result) return
  // console.log({ result })
  const { name, addDetail } = result
  const newSomething = await addingServiceMethod({ name })
  if (addDetail) nextDialogMethod(newSomething)
}

export const importSheet = async() => new Promise<string[][]> (async (resolve, reject) => {
  let data_loaded = false;
  let is_loading = false;
  const fileElement = document.createElement("input")
  fileElement.setAttribute('type','file');
  fileElement.setAttribute('accept','.xlsx,.xls,.csv')

  
  fileElement.onchange = async ($event)=> {
    
    let targetFile: File;
    if (fileElement.files && fileElement.files.length === 1 ) {
        targetFile = fileElement.files[0];
    } else {
        reject(new Error('Cannot use multiple files'))
    }

    const reader: FileReader = new FileReader();
    reader.onload = async (e: any) => {
      data_loaded = true;
      is_loading = true

      /* read workbook */
      const bstr: string = e.target.result;
      const wb:any = XLSX.read(bstr, {type: 'binary'});

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws:any = wb.Sheets[wsname];

      /* save data */
      const data = <string[][]>(XLSX.utils.sheet_to_json(ws, {header: 1}))
      resolve(data.map(r => r.map(cell => {
        if (cell) {
          try {
            return cell.trim()
          } catch (e) {
            console.log("Couldn't trim cell", cell)
          }
        }
        return cell
      })))
    };
    reader.readAsBinaryString(targetFile)
  }
  fileElement.click();
})

export const importTableData = async(type:ImportType, dialog: MatDialog, addingServiceMethod)=>{
  
  const data: ImportDialogData = { type }
  const sheet = await importSheet()
  data.sheet = sheet
  const result = await openDialogGetResult<ImportDialogComponent>(dialog, ImportDialogComponent, {panelClass:'full-screen-modal', data})
  if (!result || !result['entries']) return
  console.log('success, now we need to tell the user ',result)
  addingServiceMethod(result['entries'])
  
}

export const saveTable = async<R extends BaseTableData>(type: string, defaultName: string, dialog: MatDialog, nestedTable: NestedTableComponent<R>, elementId = 'toggle-menu', dataType: 'table' | 'budget' = 'table') => {
  const rect = document.getElementById(elementId).getBoundingClientRect()
  const width = 320 // NEEDS to be wider for performer, or you need to deal with padding issues.  This is a better solution imo
  const data: InputDialogData = {
    title: `Export ${type} ${dataType} to csv`,
    currentValue: makeStringFileNameSafe(defaultName),
    placeholder: 'Enter a filename for the csv',
    backgroundColor: null,
    successLabel: 'EXPORT TO CSV',
    small: true,
    position: { top: rect.bottom + 5, left: rect.right - width },
  }
  const result = await openDialogGetResult<InputDialogReturnData>(dialog, InputDialogComponent, { width: `${width}px`, autoFocus: true, backdropClass: 'clear', data })
  // console.log({ result })
  if (!result) return

  const fileName = `${makeStringFileNameSafe(result.values[0])}.csv`
  if (!nestedTable) return fileName // This is for exporting budget revenue or costs, not a table

  save2DStringArrayToCSVFile(nestedTable.exportTable(), fileName)
}

export const exportBudgetSections = async(budget: Budget, ids: string[], type: 'revenue' | 'costs', matDialog: MatDialog) => {
  const fileName = await saveTable(type, `budget ${type}`, matDialog, null, 'exportButton')
  if (!fileName) return
  const sections = ids.map(id => budget.sections[id]).filter(s => s)
  
  const lines = flatten(sections.map(s => {
    const conversionRate = getConversionRate(s, budget.currency)
    const lines = s.lineItems
      .filter(li => li.description || li.item || li.unitCost || li.quantity || li.recurrence || li.total)
      .map(li => [
        li.item || '',
        li.description || '',
        li.quantity || 0,
        Math.round((li.unitCost || 0) * conversionRate * 100) / 100,
        li.recurrence || 1,
        Math.round((li.total || 0) * 100) / 100,
      ].map(cell => cell.toString()))
    return lines
  }))
  
  const data = [
    ['Item', 'Description', 'Qty', type === 'revenue' ? 'Unit Rate' : 'Unit Cost', 'Rec', 'Total'],
    ...lines
  ]
  save2DStringArrayToCSVFile(data, fileName)
}



export const editCustomQuestion = async(entityType: CoreEntityType, question: CustomQuestion, questions: CustomQuestion[], types: Ranking[], dialog: MatDialog, eventService) => {

  const { typeIds, type: questionType, question: text, isMandatory } = question

  const data: CustomQuestionDialogData = {
    type: entityType,
    dialogTitle: capitalize(entityType) + ' Profile Question',
    position: null, // not working very well 
    typeIds,
    types,
    questionType,
    text,
    isMandatory: !!isMandatory,
  }

  const sameData = await openDialogGetResult(dialog, CustomQuestionDialog, { width: '590px', disableClose: true, data })

  if (!sameData) return // cancelled

  const oldQuestion = questions.find(q => q.id === question.id) // mutate in place
  oldQuestion.typeIds = data.typeIds
  oldQuestion.question = data.text
  oldQuestion.isMandatory = !!data.isMandatory

  eventService.updateCustomQuestions(questions, entityType)
}

export const addNewCustomQuestion = async(entityType: CoreEntityType, types: Ranking[], dialog: MatDialog, eventService, questionType: CustomQuestionType = 'free') => {
  const data: CustomQuestionDialogData = {
    type: entityType,
    dialogTitle: capitalize(entityType) + ' Profile Question',
    position: null, // not working very well 
    typeIds: [],
    types,
    questionType,
    text: '',
    isNew: true
  }

  const sameData = await openDialogGetResult(dialog, CustomQuestionDialog, { width: '590px', disableClose: true, data })
  if (!sameData) return // cancelled

  const question: CustomQuestion = {
    id: createId(),
    question: data.text,
    typeIds: [...data.typeIds],
    created: new Date().getTime(),
    type: data.questionType,
    isMandatory: !!data.isMandatory,
  }
  eventService.addCustomQuestion(question, entityType)
}